<template>
  <v-card
    style="border-radius: 0 !important;"
    @keyup.enter="doLogin"
  >
    <v-card-title
      class="justify-center text-center primary--text display-3 font-weight-thin mb-5"
    >
      <v-img
        contain
        max-height="200px"
        min-height="100px"
        max-width="100%"
        :src="logo()"
      />
    </v-card-title>
    <v-card-text>
      <v-text-field
        id="email"
        v-model="identity"
        outlined
        type="email"
        label="Email"
        dense
      />
      <v-text-field
        id="password"
        v-model="password"
        outlined
        type="password"
        label="Password"
        hide-details
        dense
      />

      <v-divider class="my-5" />

      <v-btn
        block
        outlined
        rounded
        color="primary"
        :loading="isLoading"
        @click="doLogin"
      >
        Login
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Login',
  components: {},
  watch: {
    'getMyTenants': function() {
      const numTenants = this.getMyTenants.length

      if (this.getUserTenants.length === 0) {
        this.logout();
      } else if(numTenants === 1) {
        /**
         * Tenants are loaded 1 at a time...
         * So we must always check that the number of the tenants the user belongs to
         * has been loaded
         */
        if (numTenants === this.getUserTenants.length) {
          this.changeSession(this.getMyTenants[0].id)
        } else {
          this.isLoading = true
        }
      } else if(numTenants > 1) {
        this.setSessionDialog(true)
      }
    }
  },
  computed: {
    ...mapGetters([ 'getMyTenants', 'getUserTenants' ])
  },
  data() {
    return {
      isLoading: false,
      identity: '',
      password: ''
    }
  },
  methods: {
    ...mapActions([ 'login', 'setSessionDialog', 'logout', 'changeSession' ]),
    doChangeSession() {

    },
    doAskSession() {

    },
    doLogin() {
      this.isLoading = true

      const payload = {
        identity: this.identity,
        password: this.password
      }
      this.login(payload)
        .then()
        .catch()
        .finally(() => { this.isLoading = false })
    },
    logo() {
      let logoImg;

      try {
        logoImg = require(`@/assets/themes/${process.env.VUE_APP_THEME}/logo.svg`)
      }catch (e) {

      }

      if (!logoImg) {
        try {
          logoImg = require(`@/assets/themes/${process.env.VUE_APP_THEME}/logo.png`)
        }catch (e) {

        }
      }

      return logoImg
    }
  }
}
</script>
